export default function classes(...styles) {
  let combined = ''
  styles.forEach(name => {
    if (name) {
      if (!combined) {
        combined = name
      } else {
        combined += ` ${name}`
      }
    }
  })
  return combined
}
